<!--  -->
<template>
  <div class="dialog-search-container" >
     <!-- <keep-alive> -->
        <div class="dialog-search-xuni" v-show="!dialog">
            <div>
                <iconx type="sousuo1" style="font-size: 15px"> </iconx>
                <input type="text" 
                  placeholder=" 搜索景点，周边服务点" @click="inputSearchList"  />
            </div>
            
        </div>
      
        <div class="dialog-bottom-tab" v-show="!dialog">
            <div class="dialog-home">
              
            <div class="tab_home" :class="activeIndex==0 ? 'on':''" @click="addClass(0,null,list)">
          
              <div >{{isEnglish ? tarMap[0].english: tarMap[0].chinese}}</div>
            </div>
          
          
            <div class="tab_home"   v-show="second_service_category.length>0"
                v-for="(v,i) in second_service_category" :key="v.name"
                @click="addClass(i+100,v,second_service)"
                :class="activeIndex==i+100 ? 'on':''"
              >
            
                  <div >{{isEnglish?v.name_eng:v.name}}</div>
              
            </div>
          
          
            
            <div class="tab_home" @click="addClass(2,null,serverAddressList)" :class="activeIndex==2 ? 'on':''" v-show="serviceCenter">
            
              <div >{{ isEnglish ? tarMap[2].english : tarMap[2].chinese }}</div>
            </div>

            <div class="tab_home" v-for="(item,index)  in serviceList" :key="index" @click="addClass(index+3,item,serverAddressList)" 
            v-show="!serviceCenter"
              :class="activeIndex==index+3 ? 'on':''"
            >
            
              <div >{{ isEnglish?item.name_eng:item.name}}</div>
            </div>

            <div class="tab_home" @click="addClass(1,null,lineAddressList)" :class="activeIndex==1 ? 'on':''">
            
              <div >{{isEnglish ? tarMap[1].english: tarMap[1].chinese}}</div>
            </div>

            

        
            </div>
            <div class="tab-main">
                <!-- 景点 -->
                <div v-if="activeIndex === 0" class="tab-main-list">
                    
                    <ul class="search-list">
                    
                      <template >
                        <li
                          class="search-item"
                          v-for="(item, index) in list"
                          :key="item.id"
                          @click="setCenter(item, index)"
                      >
                          <div class="flex-left">
                          <div class="icon-first">
                              <img
                              :src="baseImgHost+imgArr[index]"
                              alt
                              />
                          </div>
                          <div>
                            <p :class="{ 'set-font': isEnglish }" class="name-cont">{{ isEnglish ? item.name_eng : item.name }}

                              <span >
                                  {{ juli[index]}}
                              </span>
                            </p>
                            <div class="innerhtml">
                              <p v-if="isEnglish" v-html="item.content_eng">

                              </p>
                              <p v-else v-html="item.content">

                              </p>
                            </div>
                          </div>
                        
                        
                          </div>
                      </li>
                      </template>
                    </ul>
                    
                </div>
                <!-- 路线规划 -->
                <div v-if="activeIndex === 1"  class="tab-main-list">
                    <ul class="server-list">
                    <li
                        class="server-item"
                        v-for="(item, index) in lineAddressList"
                        :key="index"
                        @click="setLineVis(item, index)"
                    >
                        <div class="flex-left list-item">
                        <iconx color='rgb(255, 170, 3)' type='luxian' size='18'/>
                        <span class="name-cont">
                            {{ isEnglish ? item.name_eng : item.name }}
                        </span>
                        <iconx color='rgb(255, 170, 3)' type='duigou' size='18'  v-show="lineActiveIndex === index"/>
                        </div>
                    </li>
                    </ul>
                </div>
                <!--服务中心-->
                <div v-if="activeIndex === 2"  class="tab-main-list">
                    <ul class="server-list" v-if="serverClassList.length === 0">
                       <template >
                    <li
                        class="server-item"
                        v-for="(item, index) in serverAddressList"
                        :key="index"
                        @click="setServerCenter(item, index)"
                    >
                        <div class="flex-left list-item">
                        <!-- <span class="icon-first">
                        <img :src="item.icon" alt style="width: 30px; height: 30px" class="icon-first"/>
                        </span> -->
                        <img :src="item.icon" alt="">
                        <span :class="{ 'set-font': isEnglish }" class="name-cont">
                            {{ isEnglish ? item.name_eng : item.name }}
                        </span>
                      
                        </div>
                    </li>
                     </template>
                    </ul>
                    <ul v-else class="server-class-list">
                    <li v-for="(item, index) in serverClassList"  :key="index"  @click="changeServerClass(item, index)" >
                        <span :style="{backgroundColor: classIndex === index ? 'rgb(255, 212, 92)' : '#eee'}">
                        {{ isEnglish? item.name_eng : item.name }}
                        </span>
                    </li>
                    </ul>
                </div>
                <!-- 二级导览 -->
                <div v-for="(v,i) in second_service_category" :key="i" v-show="activeIndex === i+100"   class="tab-main-list">
                    <ul class="search-list" >
                    <li
                        class="search-item"
                        v-for="(item, index) in second_service"
                        :key="item.id"
                        @click="setServerCenter(item, index)"
                    v-show="item.className==v.name"
                    >
                        <div class="flex-left list-item">
                          <img :src="item.icon" alt="">
                          <span :class="{ 'set-font': isEnglish }" class="name-cont" style="left:10px">{{ isEnglish?item.name_eng :item.name }}</span>

                        </div>
                    </li>
                    </ul>
                    <!-- <p v-if="!searchList.length" class="search-title">
                    {{isEnglish ? botMap[2].english: botMap[2].chinese}}'{{ searchTitle }}'{{ isEnglish? botMap[3].english : botMap[3].chinese}}
                    </p> -->
                </div>
            
                <div v-for="(v,index)  in serviceList" :key="index" v-show="activeIndex===index+3"  class="tab-main-list">
            
                <ul class="search-list" >
                    <li
                        class="search-item"
                        v-for="(item, index) in serverAddressList"
                        :key="index"
                        @click="setServerCenter(item, index)"
                        v-show="item.className==v.name"
                    >
                        <div class="flex-left list-item">
                        <img :src="item.icon" alt="">
                        <span :class="{ 'set-font': isEnglish }" class="name-cont" style="left:10px">{{ isEnglish ? item.name_eng : item.name }}</span>
                        
                        
                        </div>
                    </li>
                  </ul>
                    <p v-if="!list.length" class="search-title">
                    {{isEnglish ? botMap[2].english: botMap[2].chinese}}{{ isEnglish? botMap[3].english : botMap[3].chinese}}
                    </p>
                </div>
            </div>
        </div>
   
    
  <!-- </keep-alive> -->

    <div class="mark" v-show="dialog">
       <div class="dialog-search-xuni2 dialog-search-xuni" >
        <div>
             <iconx type="sousuo1" style="font-size: 15px"> </iconx>
             <input type="text" 
              placeholder=" 搜索景点，周边服务点" @input="sousuo" v-model="searchValue"  ref="seach_input"/>
        </div>
        <span @click="out">取消</span>
       </div>
       <div class="searchResult">
          <div v-for="(item,keay,index) in searchListjingdian" :key="index">
              <template v-if="keay=='景点'">
                <h2>{{keay}}</h2>
                <div class="xiangqing" v-for="(v,i) in item" :key="i"  @click="setCenter(v,i)">
                   <div class="tourIcon">
                      <img  :src="baseImgHost+v.img" alt="" >
                   </div>
                    
                    <div class="msg">
                        <p class="tourname">{{ isEnglish ? v.name_eng : v.name }}
                            <span>{{searchJuli[keay][i]}}</span>

                        </p>
                        <div class="innerhtml">
                              <p v-if="isEnglish" v-html="v.content_eng">

                              </p>
                              <p v-else v-html="v.content">

                              </p>
                        </div>
                    </div>
                </div>
              </template>
               <template v-else>
                <h2>{{keay}}</h2>
                <div class="xiangqing" v-for="(v,i) in item" :key="i" @click="setServerCenter(v,i)">
                    <!-- <img  v-lazy="'https://f0.xiaoniren.cn'+v.img" alt="" class="tourIcon" v-if="keay=='景点'"> -->
                    <img  :src="v.icon" alt="" class='fuwuIcon'>
                    <p class="tourname"> {{isEnglish?v.name_eng: v.name}}
                       <span>{{searchJuli[keay][i]}}</span>
                    </p>
                </div>
              </template>
          </div>
       </div>
    </div>
    
  </div>
</template>
<script>
import iconx from "@/components/iconx.vue";
import * as constMap from "@/static/const.js";
import * as config from "../api/api.js"
import eventBus from "@/utils/eventBus.js";
import { distanceEnglishMap } from "@/static/const.js";
import { baseImgHost} from "@/api/api.js"


export default {
  name:"searchCom",
  components: {
    iconx,
  },
  props: {
    info: {
      type: Object,
      default: () => {},
    },
    list: {
      type: Array,
      default: () => [],
    },
    spointx: {
      type: Number,
      default: null,
    },
    spointy: {
      type: Number,
      default: null,
    },
    isEnglish: {
      type: Boolean,
      default: false,
    },
    choseTour:{
      type:Function,
      
    },
    closeDialog:{
       type:Function,
    },
    
  },
  name: "search",
  data() {
    return {
      searchValue:"",
      audioInfo: {},
      audioList: [],
      activeIndex: 0,
      serverClassList: [],
      serviceList: [],
      second_service: [], //二级导览列表
      second_service_category: [], //二级导览导航
      tarMap: constMap.tarberEnglishMap,
      botMap: constMap.bottomListEnglishMap,
      serviceCenter: false,
      isShowList:true,
      serverAddressList: [], // 服务中心列表
      juli:[],
      isCheckedId: null,
      lineActiveIndex:0,
      checkServerIndex: null,
      classNameList:[],//根据所选的title 进行模糊搜索
      classNmae:"",
      searchListjingdian:{},
      dialog:false,
      searchJuli:[],
      imgArr:[],
      lineAddressList:[],
      classIndex:0,
      baseImgHost
    };
  },
  watch: {
    info: {
      handler(val) {
        this.serverClassList = [...val.serverClassList] || [];
        this.serviceList = [...val.serverClassList] || [];
        this.second_service = [...val.second_service] || [];
        this.second_service_category = [...val.second_service_category] || [];

        if (config.client === "h5") {
          this.serviceCenter = false;
          if (val.serverClassList.length == 0) {
            this.serviceCenter = true;
          } else {
            this.serviceCenter = false;
          }
        } else {
          this.serviceCenter = true;
        }
         this.serverAddressList = val.inlet_and_outlet;
        this.lineAddressList = val.path_planning;
        this.serverAddressList.forEach((item) => {
          this.$set(item, "isChecked", false);
        });
      },
    },
    spointx(val){
      this.spointx=val
      // console.log(this.spointx, this.spointy)
      this.handler(this.list)

    },
    spointy(val){
      this.spointy=val
      this.handler(this.list)
    },
    list(val) {
      // console.log(val)
      this.handler(val)
      if(val){
        let arr=[]
        val.forEach((v,i)=>{
          arr.push(v.img)
        })
        localStorage.setItem("imgArr",
        JSON.stringify(arr))
      }
    },
    activeIndex(val){
      if(val==0){
       
      }
    },
    
  },
  created() {
    
     
  },
  
  mounted() {
    let that=this
   this.imgArr=JSON.parse(  localStorage.getItem("imgArr"))
  },
  methods:{
    handler(newVal) {
        
         this.classNameList=this.list
        let newLagLng = new TMap.LatLng(this.spointx, this.spointy);
        this.juli=[]
        newVal.forEach((v,i)=>{
          let loglat = v.coordinate.split(",");
          let path = [newLagLng, new TMap.LatLng(loglat[1], loglat[0])];
          let distance = Math.floor(TMap.geometry.computeDistance(path)) + "";
          // console.log(distance)
            if (distance.length >= 4) {
              this.juli.push (
                (distance / 1000).toFixed(3) +
               "km"
              );
            } else {
              this.juli.push (
                distance +
                "m"
              );
            }
          
          
        })
        // console.log(this.juli)
        
      },
    //搜索框点击
    inputSearchList(){
      this.dialog=true
      this.searchValue=""
      this.searchListjingdian={}
      this.$nextTick(() => {
       
          this.$refs.seach_input.focus()
        
      })
      
    },
    //搜索框搜索
    sousuo(){
      
        config.searchTour({
          name:this.searchValue,
          id:config.AudioId
        }).then(res=>{
          
          let arr=[]
          let newLagLng = new TMap.LatLng(this.spointx, this.spointy);
            this.searchListjingdian=res.data.data
            if(res.data.data){
              
              for(let key in res.data.data){
                console.log(key)
                arr[key]=[]
                res.data.data[key].forEach((v,i)=>{
                  let loglat = v.coordinate?v.coordinate.split(","):v.longitude.split(",");
                  let path = [newLagLng, new TMap.LatLng(loglat[1], loglat[0])];
                  let distance = Math.floor(TMap.geometry.computeDistance(path)) + "";
                  console.log(distance)
                   if (distance.length >= 4) {
                      arr[key].push (
                        (distance / 1000).toFixed(3) +
                        "km"
                      );
                    } else {
                      arr[key].push (
                        distance +
                        "m"
                      );
                    }
                })
                this.searchJuli=arr

              }
              // console.log(this.searchJuli)
              
            }
            // this.$refs.seach_input.blur()
        })
    },
    out(){
      this.dialog=false
    },
    //nav导航点击
    addClass(index,item,arr) {
     
      if(item){
        this.classNmae=item.name
      }
      this.classNameList=arr
      if(index>2 || index<0){
        this.changeServerClass(item,index,true)
      }
      if(index==0){
      this.$emit("choseTour",{tourInfo:item,isShow:true})

      }
      this.activeIndex = index;
      eventBus.emit("remove", index);
      // if(index==0 || index==1 ){
        this.isShowList = true;
      // }
    },
    changeServerClass(data, index,isShow) {
     
      eventBus.emit('changeSeverMaker', data)
    },
    //景点点击
    setCenter(data, index) {
      console.log(data)
      this.dialog=false
      this.searchValue=""
      
      if (this.isCheckedId) {
        let item = this.list.find((item) => {
          return this.isCheckedId === item.id;
        });
        if (item) {
          item.isChecked = false;
        }
      }
      // this.searchList[this.checkIndex || 0].isChecked = false
      this.isCheckedId = data.id;
      data.isChecked = true;
      // this.checkIndex = index
      this.isShowList = false;
      // this.bottom = '-190px'
      eventBus.emit("showInfoWindow", data);
      this.$emit("closeDialog",false)
      this.searchListjingdian={}
    },
    //路线规划
    setLineVis(data, index) {
      this.dialog=false
      this.searchValue=""
      this.lineActiveIndex = index;
      this.isShowList=false
      eventBus.emit("setLineVis", index);
      this.$emit("closeDialog",false)
this.searchListjingdian={}
    },
    //服务设施点击
    setServerCenter(data, index) {
      console.log(data)
      let obj={...data}
      obj.name=obj.className
      this.dialog=false
      this.searchValue=""
      if (this.checkServerIndex || this.checkServerIndex === 0) {
        this.serverAddressList[this.checkServerIndex].isChecked = false;
      }
      eventBus.emit("showServerMap", data);
      // eventBus.emit('changeSeverMaker', data)

      data.isChecked = true;
      this.checkServerIndex = index;
      this.isShowList = false;
      this.$emit("closeDialog",false)
      this.searchListjingdian={}
      // this.bottom = '-190px'
    },
  }
};
</script>
<style lang="scss" scoped>
.dialog-search-container {
  width: 100%;
  height: 100%;
  
  display: flex;
  flex-direction: column;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  
}
.dialog-search-xuni {
    padding:10px 20px;
  box-sizing: border-box;
  width: 100%;

  input{
    background:none;
    border:0;
    width:75%;
    height:100%;
    outline:none;
    padding-left: 10px;
    box-sizing: border-box;
  }
  
//   
  font-size: 0.2rem;
  color: #777;
  >div{
    width: 100%;
    display: flex;
    height: 0.6rem;
    padding: 0 10px;
    box-sizing: border-box;
    /* justify-content: center; */
    align-items: center;

    border-radius: 50px;
    background: #f1f3f4;

  }
}

.dialog-bottom-tab{
    
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: auto;
    .dialog-home{
        padding: 10px 0;
        box-sizing: border-box;
        width: 100%;
        height: auto;
        border: 1px solid #ccc;
        border-right: none;
        border-left: none;
        border-top: none;
        display: flex;
        overflow-x: auto;
        >.tab_home{
            flex: none;
            width: 25%;
            font-size: 14px;
            display: flex;
            flex-direction: column;
            align-items: center;
        }
        .on{
            flex: none;
            width: 25%;
            font-size: 14px;
            display: flex;
            flex-direction: column;
            align-items: center;
            color: #FFA500;
        }
    }
    .dialog-home::-webkit-scrollbar{
        width: none;
        height: none;
        display: none;
    }
    .tab-main{
        flex: 1;
        overflow-y: auto;
        
        
    }.list-item{
        display: flex;
        align-items: center;
        font-size: 16px;
        >img{
          width: 40px;
          height: auto;
          padding-left: 10px;
          box-sizing: border-box;
        }
        .wack-duigou{
          position: absolute;
          right: 10px;
        }
        span{
          padding-left: 10px;
          box-sizing: border-box;
        }
      }
   
}
.mark{
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  overflow: auto;
  .dialog-search-xuni{
    // height: 62px;
    display: flex;
    align-items: center;
    >div{
      width: 87%;
    }
    span{
      padding-left: 8px;
      box-sizing: border-box;
    }
  }
}
.tab-main-list{
            width: 100%;
            height: 100%;
              >ul{
                width: 100%;
                height: 100%;
                li{
                    width: 100%;
                    height: auto;
                    display: flex;
                    padding: 16px 6px;
                    box-sizing: border-box;
                    .flex-left{
                      display: flex;
                      font-size: 18px;
                      >div:first-child{
                        display: flex;
                        align-items: center !important;
                        justify-content: center;
                      }
                      div{
                        display: flex;
                        // flex-direction: column;
                        // align-items: ;
                        flex-wrap: wrap;
                        align-content: space-between;
                        margin: 0 auto;
                        padding-left:8px;
                        box-sizing: border-box;
                        >p{
                          width: 100%;
                          font-weight: 900;
                          font-size: 16px;
                          display: flex;
                          justify-content: space-between;
                          
                         
                          span{
                            font-size:12px;
                            font-weight: normal;
                            color: #777;
                          }
                        }
                        .innerhtml{
                          width: 100%;
                          height: 40px;
                          overflow: hidden;
                          overflow-x: hidden;
                           overflow-y:hidden ;

                        }
                        .innerhtml>p{
                          display: -webkit-box !important;
                          -webkit-line-clamp: 2 !important;
                          -webkit-box-orient: vertical !important;
                          font-size: 12px;
                          text-overflow: ellipsis !important;
                          overflow: hidden;
                           overflow-x:hidden ;
                           overflow-y:hidden ;
                          font-weight: normal;
                        }
                      }
                       img{
                        width: 60px;
                        height: 60px;
                        border-radius: 10px;
                       }
                       
                       
                    }
                    .list-item{
                      display: flex;
                      align-items: center;
                      img{
                        width: 40px;
                        height: auto;
                        padding-left: 10px;
                        box-sizing: border-box;

                      }
                      span{
                        font-size: 16px;
                        padding-left: 10px;
                        box-sizing: border-box;

                      }
                    }
                }
                
            }
        }
.searchResult{
  flex: 1;
  // height: 100%;
  content: "";
    overflow: auto;
    border-top: 1px solid #ccc;
    // transform: scaleY(.5);
    transform-origin: left top;
    >div{
      padding: 10px;
      padding-bottom: 30px;
      box-sizing: border-box;

      .xiangqing{
        display: flex;
        padding: 10px 0;
        box-sizing: border-box;
        font-size: 14px;
        // align-items: center;
        p{
          display: flex;
          align-items: center;
          font-weight: 700;
        }
        .tourname{
          width: 100%;
          display: flex;
          justify-content: space-between;
          
          // overflow: hidden;
          // white-space: nowrap;
          // text-overflow: ellipsis;
          span{
            font-size: 12px;
            color: #777;
          }
        }
        .msg{
          flex: 1;
           display: flex;
            flex-wrap: wrap;
            // margin: 0 auto;
           
           align-content: space-between;
           padding-left: 8px;
           box-sizing: border-box;
            .innerhtml{
                          width: 100%;
                          height: 40px;
                          overflow: hidden;
                          overflow-x: hidden;
                           overflow-y:hidden ;

                        }
            .innerhtml>p{
            display: -webkit-box !important;
            -webkit-line-clamp: 2 !important;
            -webkit-box-orient: vertical !important;
            font-size: 12px;
            text-overflow: ellipsis !important;
            overflow: hidden;
            overflow-x:hidden ;
            overflow-y:hidden ;
            font-weight: normal;
            
          }
        }
        
      }

      
      
    }
    h2{
      font-size: 18px;
    }
    .tourIcon{
      display: flex;
       width: 80px;
       height: 80px;
       >img{
         width: 100%;
         height: 100%;
         border-radius: 8px;
       }

    }
    .fuwuIcon{
      width: 40px;
      height: 40px;
    }
    
}
</style>


// WEBPACK FOOTER //
// src/components/search.vue